import awards from "../../shared/fr.awards";
import branded_quotes from "../../shared/fr.branded-quotes";
import verticals from "./fr-education-secondary.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};
export default ({ page, strings }) => {
    switch (page) {
        case "fr-education-secondary-404":
            return {
                page,
                helmet: {
                    meta_title: "Site non trouvé | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.com/business/404",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-education-secondary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contact | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.com/education-superieure/contact/",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-education-secondary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-education-secondary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        case "fr-education-secondary-home":
            return {
                page,
                helmet: {
                    meta_title: "Apprentissage des langues en ligne pourl'enseignemente supérieur | Rosetta Stone",
                    meta_description:
                        "Les solutions d’apprentissage des langues Rosetta Stone pour l’enseignement supérieur donnent aux étudiants un accès direct, en ligne, à l’apprentissage de l’anglais et des langues parlées dans le monde.",
                    canonical_url: "https://www.rosettastone.fr/education-superieure/",
                    lang: "fr"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
